import { gql } from '@apollo/client';

export const GET_NAVIGATION = gql`
  query GetNavigationData(
    $teamId: Int
    $competitionId: Int!
    $seasonId: Int!
    $includeT1Games: Boolean = false
  ) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedSeasonId @client @export(as: "seasonId")
    selectedTeamId @client @export(as: "teamId")

    navigationData(
      competitionId: $competitionId
      seasonId: $seasonId
      teamId: $teamId
      includeT1Games: $includeT1Games
    ) {
      players {
        id
        name
        gamesRostered
        mostCommonNumber
        mostCommonPosition {
          id
          code
          name
          generalPosition
        }
      }
      competitions {
        id
        name
        level
      }
      seasons {
        id
        name
      }
      teams {
        id
        name
        shortName
        colorPrimary
        colorSecondary
        colorTertiary
        gameCount
      }
    }
  }
`;
